import { Flex, Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { formatDate, formatNumberCurrency } from '@blockpulse3/helpers';

type Props = {
  previousAmount: number;
  newAmount: number;
  date: Date;
};

export function InvestAmountReviewed({ previousAmount, newAmount, date }: Props): JSX.Element {
  const i18nSubscriberDetailsSidePanel = useTranslations('SubscriberDetailsSidePanel');

  return (
    <Stack spacing={1}>
      <Text fontSize="sm">
        {i18nSubscriberDetailsSidePanel.rich('Activity.InvestAmountReviewed.Title', {
          amount: formatNumberCurrency(newAmount),
          important: (chunks) => (
            <Text as="span" fontWeight="600">
              {chunks}
            </Text>
          ),
        })}
      </Text>
      <Stack color="gray.500" spacing={1}>
        <Flex justifyContent="space-between">
          <Text>{i18nSubscriberDetailsSidePanel('Activity.InvestAmountReviewed.Date')}:</Text>
          <Text>{formatDate(date, 'DD/MM/YYYY')}</Text>
        </Flex>
        <Flex justifyContent="space-between">
          <Text>
            {i18nSubscriberDetailsSidePanel('Activity.InvestAmountReviewed.PreviousAmount')}:
          </Text>
          <Text>{formatNumberCurrency(previousAmount)}</Text>
        </Flex>
      </Stack>
    </Stack>
  );
}
